<mat-card-title class="custom-card-title">
  {{ data.titleKey | translate }}
  <button aria-label="Close" type="button" class="dialog-close-btn" (click)="close()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</mat-card-title>

<mat-dialog-content>
  @if (data.subtitle) {
    <div class="reason-subject">{{ data.subtitle }}</div>
  }

  @if (data.quote) {
    <blockquote class="reason-quote">
      <p>{{ data.quote }}</p>
      @if (data.quoteMeta) {
        <footer>{{ data.quoteMeta }}</footer>
      }
    </blockquote>
  }

  @if (data.warningKey) {
    <div class="reason-warning">
      <mat-icon class="m-r-2">info_outline</mat-icon>
      <span>{{ data.warningKey | translate: data.params }}</span>
    </div>
  }

  <form class="reason-dialog-form" [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ data.labelKey | translate }} <span class="required-asterisk">*</span></mat-label>
      <textarea [maxlength]="maxLength" cdkFocusInitial formControlName="reason" matInput rows="3" required></textarea>
      @if ((form.get('reason')?.hasError('required') || form.get('reason')?.hasError('pattern')) && form.get('reason')?.touched) {
        <mat-error>{{ 'COMMON.REASON_REQUIRED' | translate }}</mat-error>
      } @else if (data.hintKey) {
        <mat-hint class="reason-hint">{{ data.hintKey | translate: data.params }}</mat-hint>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" (click)="close()" mat-stroked-button>{{ 'COMMON.CANCEL' | translate }}</button>
  <button type="button" [disabled]="form.invalid" (click)="save()" mat-flat-button color="warn">{{ data.confirmKey | translate }}</button>
</mat-dialog-actions>
